import * as List from "./List/index.js";
import * as Summary from "./Summary/index.js";
/** CoStar.Api.FusionSearch.Result.AdType */
export var AdType;
(function (AdType) {
    AdType[AdType["NoAd"] = 0] = "NoAd";
    AdType[AdType["Normal"] = 1] = "Normal";
    AdType[AdType["Enhanced"] = 2] = "Enhanced";
})(AdType || (AdType = {}));
/** CoStar.Api.FusionSearch.Result.BuildingCertifications */
export var BuildingCertifications;
(function (BuildingCertifications) {
    BuildingCertifications[BuildingCertifications["None"] = 0] = "None";
    BuildingCertifications[BuildingCertifications["EnergyStar"] = 1] = "EnergyStar";
    BuildingCertifications[BuildingCertifications["LEED"] = 2] = "LEED";
    BuildingCertifications[BuildingCertifications["BREEAM"] = 4] = "BREEAM";
    BuildingCertifications[BuildingCertifications["LEED_CANADA"] = 8] = "LEED_CANADA";
})(BuildingCertifications || (BuildingCertifications = {}));
/** CoStar.Api.FusionSearch.Result.SaleCompEntityType */
export var SaleCompEntityType;
(function (SaleCompEntityType) {
    SaleCompEntityType[SaleCompEntityType["None"] = 0] = "None";
    SaleCompEntityType[SaleCompEntityType["ForSale"] = 1] = "ForSale";
    SaleCompEntityType[SaleCompEntityType["PortfolioComp"] = 2] = "PortfolioComp";
    SaleCompEntityType[SaleCompEntityType["ChildComp"] = 3] = "ChildComp";
})(SaleCompEntityType || (SaleCompEntityType = {}));
export { List, Summary };
